"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingSignedUrlToJSON = exports.OnboardingSignedUrlFromJSONTyped = exports.OnboardingSignedUrlFromJSON = void 0;
function OnboardingSignedUrlFromJSON(json) {
    return OnboardingSignedUrlFromJSONTyped(json, false);
}
exports.OnboardingSignedUrlFromJSON = OnboardingSignedUrlFromJSON;
function OnboardingSignedUrlFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'signedUrlKey': json['signedUrlKey'],
        'signedUrl': json['signedUrl'],
    };
}
exports.OnboardingSignedUrlFromJSONTyped = OnboardingSignedUrlFromJSONTyped;
function OnboardingSignedUrlToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'signedUrlKey': value.signedUrlKey,
        'signedUrl': value.signedUrl,
    };
}
exports.OnboardingSignedUrlToJSON = OnboardingSignedUrlToJSON;
